import { render, staticRenderFns } from "./PasswordResetMyAccount.vue?vue&type=template&id=2d44483a&scoped=true&"
import script from "./PasswordResetMyAccount.vue?vue&type=script&lang=js&"
export * from "./PasswordResetMyAccount.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetMyAccount.vue?vue&type=style&index=0&id=2d44483a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44483a",
  null
  
)

export default component.exports